import { RxDocument } from 'rxdb'
import { IS_OFFLINE_ID } from 'models/helpers'
import { BaseSchema } from '../models/helpers/BaseSchema'

// Entities
const docPersisted = (doc: RxDocument<BaseSchema>) => !doc || IS_OFFLINE_ID(doc.id) ? 'Cannot choose a local document' : null

export const docValidators = {
  docPersisted,
}
